/**
 *
 * Asynchronously loads the component for Assessment
 *
 */
import React from 'react';
import loadable from 'utils/loadable';
import LoadingIndicator from 'components/LoadingIndicator';

import { getLocalData } from 'utils/localDataStore';

// Pre-create the loadable components
const BlueshieldcaAssessmentResult = loadable(
  () => import('./clients/BlueshieldcaAssessmentResult'),
  {
    fallback: <LoadingIndicator />,
  },
);

const AssessmentResultIndex = loadable(() => import('./index'), {
  fallback: <LoadingIndicator />,
});

const LoadableAssessmentResult = () => {
  const brand = getLocalData('brand')?.toLowerCase();

  switch (brand) {
    case 'blueshieldca':
    case 'bscsmartscreen':
    case 'bscsmartscreenuat':
      return <BlueshieldcaAssessmentResult />;
    default:
      return <AssessmentResultIndex />;
  }
};

export default LoadableAssessmentResult;
